export class MalnutritionPhaseHelper {

    public static SEVERE_ACUTE_MALNUTRITION = {
        value: 'SEVERE_ACUTE_MALNUTRITION',
        i18nkey: 'severeAcuteMalnutrition',
        text: 'Desnutrición aguda severa'
    };

    public static ACUTE_MALNUTRITION = {
        value: 'ACUTE_MALNUTRITION',
        i18nkey: 'acuteMalnutrition',
        text: 'Desnutrición aguda'
    };

    public static MODERATE_ACUTE_MALNUTRITION = {
        value: 'MODERATE_ACUTE_MALNUTRITION',
        i18nkey: 'moderateAcuteMalnutrition',
        text: 'Desnutrición aguda moderada'
    };

    public static RISK_OF_ACUTE_MALNUTRITION = {
        value: 'RISK_OF_ACUTE_MALNUTRITION',
        i18nkey: 'riskOfAcutemalnutrition',
        text: 'Riesgo de desnutrición aguda',
    };

    public static OUT_OF_RISK_ZONE = {
        value: 'OUT_OF_RISK_ZONE',
        i18nkey: 'outOfRiskZone',
        text: 'Fuera de la zona de riesgo'
    };

    public static HEALED_CHILD = {
        value: 'HEALED_CHILD',
        i18nkey: 'healedChild',
        text: 'Niño recuperado'
    };
    public static HEALED_WOMAN = {
        value: 'HEALED_WOMAN',
        i18nkey: 'healedWoman',
        text: 'Mujer recuperada'
    };

    public static NO_MEASURED = {
        value: 'NO_MEASURED',
        i18nkey: 'noMeasured',
        text: 'No Medido'
    };

    /**
     * @deprecated
     *  This function are deprecated because this app version uses a single language
     *
     * @param marker Marker to obtain the value of key that will be used in translation (old app version)
     */
    public static findKeyByMarker(marker: string) {
        switch (marker) {
            case 'severe-acute-malnutrition':
                return MalnutritionPhaseHelper.SEVERE_ACUTE_MALNUTRITION.i18nkey;
            case 'outside-risk-zone':
            case 'outsite-risk-zone':
                return MalnutritionPhaseHelper.OUT_OF_RISK_ZONE.i18nkey;
            case 'risk-of-acute-malnutrition':
                return MalnutritionPhaseHelper.RISK_OF_ACUTE_MALNUTRITION.i18nkey;
            case 'moderate-acute-malnutrition':
                return MalnutritionPhaseHelper.MODERATE_ACUTE_MALNUTRITION.i18nkey;
            case 'healed':
                return MalnutritionPhaseHelper.HEALED_CHILD.i18nkey;
            case 'no-measured':
            default:
                return MalnutritionPhaseHelper.NO_MEASURED.i18nkey;

        }
    }

    public static listOfPhases() {
        return [MalnutritionPhaseHelper.HEALED_CHILD,
            MalnutritionPhaseHelper.MODERATE_ACUTE_MALNUTRITION,
            MalnutritionPhaseHelper.OUT_OF_RISK_ZONE,
            MalnutritionPhaseHelper.SEVERE_ACUTE_MALNUTRITION,
            MalnutritionPhaseHelper.RISK_OF_ACUTE_MALNUTRITION];
    }

}
